import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { IonBadge, IonItem, IonLabel, IonList } from "@ionic/react";
import { getTeamBreakerDiff, getTeamTableScore } from "services/util";

interface props {
  teams: any;
  quizData: any;
  progress: any;
  user: any;
}

const ResultsWinner: React.FC<props> = ({
  teams,
  quizData,
  progress,
  user,
}) => {
  const [teamStatus, setTeamStatus] = useState<any>([]);

  console.log("here");

  const score = (team: any) => {
    return getTeamTableScore(team, progress);
  };

  const sortWinners = (a: any, b: any) => {
    let n = b.score - a.score;
    if (n !== 0) {
      return n;
    }
    // console.log(a.breakerDifference - b.breakerDifference);
    return a.breakerDifference - b.breakerDifference;
  };

  useEffect(() => {
    let sorted = teams
      .map((team: any) => {
        return {
          teamName: team.teamName,
          score: score(team),
          breakerDifference: getTeamBreakerDiff(team),
        };
      })
      .sort(sortWinners); //
    setTeamStatus(sorted);
    //eslint-disable-next-line
  }, [teams]);

  // console.log(teamStatus)

  const getOrdinal = (n: number) => {
    let ord = "th";

    if (n % 10 === 1 && n % 100 !== 11) {
      ord = "st";
    } else if (n % 10 === 2 && n % 100 !== 12) {
      ord = "nd";
    } else if (n % 10 === 3 && n % 100 !== 13) {
      ord = "rd";
    }

    return n + ord;
  };

  // useEffect(() => {
  //   console.log(teamStatus);
  // });

  return (
    <IonList style={{ maxWidth: "600px" }}>
      <IonItem lines="full">
        <IonBadge slot="start" color="light">
          {getOrdinal(
            Math.min(user.assignedPrizes.length, teams.length) -
              progress.position
          )}
        </IonBadge>
        <IonLabel>
          <h2>
            {
              user.assignedPrizes[
                Math.min(user.assignedPrizes.length, teams.length) -
                  progress.position -
                  1
              ]
            }
          </h2>
          <h1>
            {
              teamStatus[
                Math.min(user.assignedPrizes.length, teams.length) -
                  progress.position -
                  1
              ]?.teamName
            }
          </h1>
        </IonLabel>
      </IonItem>
    </IonList>
  );
};
const mapStateToProps = (state: any) => ({
  quizData: state.quiz,
  teams: state.teams.teams,
  progress: state.quiz.progress,
  user: state.user.userDetails,
});

export default connect(mapStateToProps, {})(ResultsWinner);
